import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{yield}}",{ moduleName: "seshy/components/playlist/list-tabs.hbs" })